/* eslint-disable */
const elLang = require('element-plus/lib/locale/lang/ja')

module.exports = {
  languageName: '日本語',
  ...elLang.default,
  companyName: '上海境騰情報科学技術有限会社',
  invalidRoute: 'Page dose not found，please check',
  login: {    
    title: 'デバイスの検証',    
    usernamePlaceholder: 'ユーザー名を入力してください',
    passwordPlaceholder: 'パスワード入力',
    sendAuth: "認証コードの送信",
    inputAuthCode: "あなたのAuthcodeを入力してください",
    login: "ログイン",
    inputUsername: "ユーザー名を入力してください",
    inputPassword: "パスワード入力",
    tip3: 'パスワードは6ビット未満ではいけません',
    sendMessage: '認証コードの送信',
    loginBtn: 'ログイン',
    techName: 'Jingteng SaaS',
    tipText: '認証コードが送信されました',
    needStrongPass: 'あなたのパスワードはシステムのパスワードの複雑さの要求を満たしていません。修正してから続けてください。',
    tip: 'ヒント',
    submit: '確認',
    passwordError: 'アカウントまたはパスワードが間違っています',
    passwordErrorExceedLimitation: 'ユーザー名のパスワードが何度も間違っていて、アカウントがロックされて15分',
    pemissionDeny: "本システムにログインする権限がありません",
    loginError: "ログインエラー、ネットワークを確認してください",
    authcodeError: "認証コードエラー"
  },
  regist: {
    title: '新規ユーザーの作成',
    telPlaceholder: 'メールアドレスまたは電話番号を入力',
    authcodePlaceholder: '認証コード',
    sendAuth: "認証コードを送信",
    registBtn: '登録',
    privacyNote: '「Jingtengユーザー契約」と「プライバシーポリシー」に同意し、読みました。',
    usernameTip: '5-25文字、文字または漢字を含めることができます。',
    passwordTip: 'パスワードが要件を満たしていません。',
    confirmPasswordTip: '入力されたパスワードが一致しません。もう一度入力してください。',
    telTip: '携帯電話番号を入力してください。',
    authcodeTip: '認証コードを入力',
    agreementNote: '同意します',
    agreementNote1: 'および',
    privacyNote: 'プライバシーポリシー',
    EULANote: 'ユーザプロトコル',
    strongPassNote: 'パスワードは最低8文字で、大文字と小文字、数字、記号を含める必要があります',
    agreementTip: '契約に同意してください',
    userExistsTip: 'ユーザーはすでに存在します。直接ログインしてください',
    registSuccessful: '登録が成功しました。ログインしてください',
    userExists: 'ユーザーは既に存在します。他の電話番号/メールアドレスを選択してください',
    authcodeSent: '認証コードが送信されました',
    authcodeError: '認証コードの送信エラー、しばらくしてから再試行してください',
    registFailed: '申請に失敗しました。リフレッシュして再試行してください',
    confirmPassNotMatch: '2回入力したパスワードが一致しません。再入力してください'
  },
  sicialSignin:{
    aadGlobal: "Azure AD(Global)",
    aadChina: "Azure AD(China)",
    addTenantNotFound: '対応する Azure AD テナントが見つかりません。最初にテナント管理者に連絡して、Azure AD テナントをバインドしてください。',
    aadLoginError: 'AAD Login Error'
  },
  twoFactor: {
    title: '二重検証',
    note: '認証コードを取得するにはをクリックして、下に受け取った認証コードを記入し、ログインを確認してください。',
    authcodePlaceholder: 'メッセージ認証コードを入力してください',
    sendAuthcode: '認証コードの送信',
    ok: 'OK'
  },  
  codeView: {
    title: 'デバイスの検証',    
    note: 'デバイスに表示されている9桁の数字を入力してください',
    confirm: '送信',
    codeRequire: '9桁のユーザーコードを完全に入力してください',
    varified: '検証成功',
    codeError: 'コミットエラー、再入力してください'
  },
  errorView: {
    title: 'エラーが発生しました',
    note: 'エラーです！入力されたアドレス接尾辞を確認してください'
  },
  noteView: {
    success: '検証に成功しました！' ,
    note: 'デバイスに戻って続行',
    logout: "ログアウト",
    verifyAgain: "再検証"
  }
};
